import { DisconnectOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export default function UnrelatedTag() {
  return (
    <Tag>
      <DisconnectOutlined />
    </Tag>
  );
}
